import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { fadeIn, staggerContainer } from './utils/animations';

const Privacy = () => {
  useEffect(() => {
    document.title = "Privacy Policy | forca.dev";
    window.scrollTo(0, 0);
  }, []);

  return (
    <motion.div
      variants={staggerContainer(0.1, 0.1)}
      initial="hidden"
      animate="show"
      className="pt-24 pb-16 px-4"
    >
      <div className="container mx-auto max-w-4xl">
        <motion.h1 
          variants={fadeIn('down', 0.2)}
          className="text-3xl md:text-4xl font-bold text-white mb-8 text-center"
        >
          Privacy Policy
        </motion.h1>

        <motion.div
          variants={fadeIn('up', 0.3)}
          className="prose prose-invert prose-slate max-w-none"
        >
          <div className="bg-slate-900/50 border border-slate-800 rounded-xl p-6 md:p-8 shadow-xl">
            <p className="text-slate-300">Last Updated: May 7, 2025</p>

            <h2>1. Introduction</h2>
            <p>
              At forca.dev, we respect your privacy and are committed to protecting your personal data. 
              This privacy policy explains how we collect, use, and safeguard your information when you visit our website.
            </p>

            <h2>2. Information We Collect</h2>
            <p>
              We may collect the following types of information:
            </p>
            <ul>
              <li>Personal identification information (Name, email address, phone number, etc.)</li>
              <li>Usage data (how you interact with our website)</li>
              <li>Technical data (IP address, browser type, device information)</li>
            </ul>

            <h2>3. How We Use Your Information</h2>
            <p>
              We use the information we collect to:
            </p>
            <ul>
              <li>Provide and maintain our services</li>
              <li>Improve and personalize user experience</li>
              <li>Communicate with you about our services</li>
              <li>Monitor the usage of our website</li>
            </ul>

            <h2>4. Data Security</h2>
            <p>
              We implement appropriate security measures to protect your personal information from unauthorized access, 
              alteration, disclosure, or destruction.
            </p>

            <h2>5. Third-Party Services</h2>
            <p>
              We may employ third-party companies to facilitate our website, provide services on our behalf, 
              or assist us in analyzing how our website is used.
            </p>

            <h2>6. Your Data Protection Rights</h2>
            <p>
              You have the right to:
            </p>
            <ul>
              <li>Access your personal data</li>
              <li>Correct inaccurate data</li>
              <li>Request deletion of your data</li>
              <li>Object to processing of your data</li>
              <li>Data portability</li>
            </ul>

            <h2>7. Cookies Policy</h2>
            <p>
              We use cookies to enhance your experience on our website. For more information, please see our <Link to="/cookies" className="text-cyan-400 hover:text-cyan-300">Cookies Policy</Link>.
            </p>

            <h2>8. Changes to This Privacy Policy</h2>
            <p>
              We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new 
              Privacy Policy on this page and updating the "Last Updated" date.
            </p>

            <h2>9. Contact Us</h2>
            <p>
              If you have any questions about this Privacy Policy, please contact us at:
            </p>
            <p className="text-cyan-400">info@forca.dev</p>
          </div>
        </motion.div>
      </div>
    </motion.div>
  );
};

export default Privacy;